export default __webpack_public_path__ + "static/media/hero-caro-new-2.df02a04e.png";